export default "__VITE_ASSET__eddb12fe__"